import { NodeAspect } from './node-aspect';
import { Item} from "../data/entities/entities";
export class TreeViewItem extends Item {
    id:number;
    name: string;
    entityStatusId;
    description: string;
    children: Array<any>;
    parentId: number;
    parent:TreeViewItem;
    nodeAspect: NodeAspect;
}